import React from "react";
import { processImagePath } from "../../../../util/Functions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";


export default function ProductAttributeVariationButton({ active, icon, image, color, type, layout, text, onClick, dataId, distance, selected }) {
	const classes = [
		"variation",
		active && 'active',
		icon && 'has-icon',
		image && 'has-image',
		color && 'has-swatch',
		selected && "current",
	].filter(v => v).join(' ');

	const dataset = {
		"data-component": "ProductAttributeVariationButton",
		"data-id": dataId,
		"data-distance": distance,
		"data-layout": layout,
	}

	return (
		<button
			onClick={onClick}
			color={color}
			icon={icon}
			className={classes}

			{...dataset}
		>
			{
				color
				&& !image
				&& (<span className='indicator' style={{ backgroundColor: color }}></span>)
			}
			{
				image
				&& (<img src={processImagePath(image, 'mini')} alt={text} />)
			}
			{
				(type !== 'icon')
					? text
					: (
						<OverlayTrigger overlay={<Tooltip className="_boss tooltip-info">{text}</Tooltip>}>
							{text && (<img src={processImagePath(icon)} alt={text} />)}
						</OverlayTrigger>
					)
			}
			{(type === 'icon') && (<div className="label">{text}</div>)}
		</button>
	);
}
